(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iq-usp-leiste-pro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iq-usp-strip')) {
    customElements.define('iq-usp-strip', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.initialize(); });
      }

      initialize() {
        this.track = this.querySelector('[data-usp-track]');
        if (!this.track || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.items = Array.from(this.track.children);
        this.controls = this.querySelector('[data-usp-controls]');
        this.previous = this.querySelector('[data-usp-prev]');
        this.next = this.querySelector('[data-usp-next]');
        this.dots = Array.from(this.querySelectorAll('[data-usp-dot]'));
        this.pauseButton = this.querySelector('[data-usp-pause]');
        this.mobileQuery = matchMedia('(max-width: 749px)');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.pages = [];
        this.previous?.addEventListener('click', () => this.move(-1, true), options);
        this.next?.addEventListener('click', () => this.move(1, true), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index, true), options));
        this.pauseButton?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updatePauseButton();
          this.scheduleAutoplay();
        }, options);
        this.track.addEventListener('scroll', () => this.queueUpdate(), { ...options, passive: true });
        this.track.addEventListener('pointerdown', () => this.pauseForUser(), options);
        this.track.addEventListener('keydown', event => {
          if (!this.active || event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const rtl = getComputedStyle(this.track).direction === 'rtl';
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1), true);
          }
        }, options);
        this.addEventListener('pointerenter', () => { this.hovered = true; this.scheduleAutoplay(); }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.scheduleAutoplay(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.scheduleAutoplay(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.scheduleAutoplay(); }, options);
        this.mobileQuery.addEventListener('change', () => this.measure(), options);
        this.motionQuery.addEventListener('change', () => { this.updatePauseButton(); this.scheduleAutoplay(); }, options);
        document.addEventListener('visibilitychange', () => this.scheduleAutoplay(), options);
        document.addEventListener('shopify:block:select', event => {
          const item = this.items.find(element => element.dataset.blockId === event.detail?.blockId);
          if (!item) return;
          this.editorSelected = true;
          this.scheduleAutoplay();
          if (this.active) {
            const bounds = this.track.getBoundingClientRect();
            const box = item.getBoundingClientRect();
            const delta = this.rtl ? box.right - bounds.right : box.left - bounds.left;
            this.track.scrollBy({ left: delta, behavior: 'instant' });
          }
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.items.some(element => element.dataset.blockId === event.detail?.blockId)) return;
          this.editorSelected = false;
          this.scheduleAutoplay();
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inViewport = entries[0].isIntersecting;
          this.scheduleAutoplay();
        });
        this.intersectionObserver.observe(this);
        this.measure();
        this.updatePauseButton();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        clearTimeout(this.autoplayTimer);
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = null;
      }

      measure() {
        this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.active = this.dataset.mobileLayout === 'slider' && this.mobileQuery.matches && this.maxScroll > 2;
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.tabIndex = this.active ? 0 : -1;
        this.pages = [];
        if (this.active) {
          const base = this.items[0].getBoundingClientRect();
          this.items.forEach(item => {
            const bounds = item.getBoundingClientRect();
            const offset = this.rtl ? base.right - bounds.right : bounds.left - base.left;
            const position = Math.min(this.maxScroll, Math.max(0, offset));
            if (!this.pages.length || Math.abs(position - this.pages[this.pages.length - 1]) > 2) this.pages.push(position);
          });
        }
        if (this.controls) this.controls.hidden = !this.active || !this.controls.children.length;
        this.dots.forEach((dot, index) => { dot.hidden = index >= this.pages.length; });
        this.update();
        this.scheduleAutoplay();
      }

      queueUpdate() {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => { this.updateFrame = null; this.update(); });
      }

      update() {
        if (!this.active || !this.pages.length) return;
        const offset = Math.abs(this.track.scrollLeft);
        this.current = this.pages.reduce((best, value, index) => Math.abs(value - offset) < Math.abs(this.pages[best] - offset) ? index : best, 0);
        if (this.previous) this.previous.disabled = this.current === 0;
        if (this.next) this.next.disabled = this.current === this.pages.length - 1;
        this.dots.forEach((dot, index) => {
          if (index === this.current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      go(index, manual = false) {
        if (!this.active || !this.pages.length) return;
        if (manual) this.pauseForUser();
        const page = Math.max(0, Math.min(this.pages.length - 1, index));
        this.track.scrollTo({ left: this.pages[page] * (this.rtl ? -1 : 1), behavior: this.motionQuery.matches ? 'instant' : 'smooth' });
      }

      move(direction, manual = false) { this.go((this.current || 0) + direction, manual); }

      pauseForUser() {
        if (this.dataset.autoplay !== 'true') return;
        this.userPaused = true;
        this.updatePauseButton();
        this.scheduleAutoplay();
      }

      updatePauseButton() {
        if (!this.pauseButton) return;
        const paused = this.userPaused || this.motionQuery.matches;
        this.pauseButton.disabled = this.motionQuery.matches;
        this.pauseButton.setAttribute('aria-pressed', String(paused));
        this.pauseButton.setAttribute('aria-label', paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.querySelector('[data-pause-icon]').hidden = paused;
        this.pauseButton.querySelector('[data-play-icon]').hidden = !paused;
      }

      scheduleAutoplay() {
        clearTimeout(this.autoplayTimer);
        if (!this.isConnected || !this.active || this.dataset.autoplay !== 'true' || this.userPaused || this.motionQuery.matches || this.hovered || this.focused || this.editorSelected || document.hidden || !this.inViewport) return;
        this.autoplayTimer = setTimeout(() => {
          this.go((this.current + 1) % this.pages.length);
          this.scheduleAutoplay();
        }, Math.max(3000, Number(this.dataset.interval) || 5000));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iq_laufschrift"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iq-announcement-marquee')) {
    customElements.define('iq-announcement-marquee', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        if (!this.querySelector('[data-iqah-end]')) {
          this.readinessObserver = new MutationObserver(() => {
            if (this.querySelector('[data-iqah-end]')) {
              this.readinessObserver.disconnect();
              this.start();
            }
          });
          this.readinessObserver.observe(this, { childList: true, subtree: true });
          return;
        }
        this.start();
      }

      disconnectedCallback() {
        this.readinessObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.abortController?.abort();
        cancelAnimationFrame(this.frame);
        this.abortController = null;
        this.lastSize = '';
      }

      start() {
        if (this.abortController || !this.isConnected) return;
        this.viewport = this.querySelector('[data-iqah-viewport]');
        this.track = this.querySelector('[data-iqah-track]');
        this.source = this.querySelector('[data-iqah-source]');
        this.pauseButton = this.querySelector('[data-iqah-pause]');
        if (!this.viewport || !this.track || !this.source) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 750px)');
        this.lastSize = '';
        this.reducedMotion.addEventListener('change', () => this.scheduleBuild(), { signal });
        window.addEventListener('resize', () => this.scheduleBuild(), { signal, passive: true });
        document.addEventListener('visibilitychange', () => {
          this.toggleAttribute('data-document-hidden', document.hidden);
        }, { signal });

        this.pauseButton?.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          this.pauseButton.setAttribute('aria-pressed', String(paused));
          this.pauseButton.setAttribute('aria-label', paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        }, { signal });

        this.addEventListener('focusin', (event) => {
          const link = event.target.closest('a.iqah-message');
          if (!link || !this.source.contains(link)) return;
          this.setAttribute('data-focus-link', '');
          this.viewport.scrollLeft = Math.max(0, link.offsetLeft - 16);
        }, { signal });

        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (signal.aborted || this.contains(document.activeElement)) return;
            this.removeAttribute('data-focus-link');
            this.viewport.scrollLeft = 0;
          });
        }, { signal });

        this.addEventListener('shopify:block:select', (event) => {
          const item = Array.from(this.source.children).find((child) => child.dataset.iqahItem === event.detail?.blockId);
          if (!item) return;
          this.setAttribute('data-editor-selected', '');
          this.viewport.scrollLeft = Math.max(0, item.offsetLeft - 16);
        }, { signal });

        this.addEventListener('shopify:block:deselect', () => {
          this.removeAttribute('data-editor-selected');
          this.viewport.scrollLeft = 0;
        }, { signal });

        this.resizeObserver = new ResizeObserver(() => this.scheduleBuild());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.source);
        document.fonts?.ready.then(() => {
          if (!signal.aborted) this.scheduleBuild();
        });
        this.toggleAttribute('data-document-hidden', document.hidden);
        this.scheduleBuild();
      }

      scheduleBuild() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.build());
      }

      build() {
        if (!this.isConnected || !this.source || !this.viewport) return;
        const width = this.source.getBoundingClientRect().width;
        const viewportWidth = this.viewport.clientWidth;
        if (width < 1 || viewportWidth < 1) return;

        const configuredSpeed = Number(this.desktop.matches ? this.dataset.speedDesktop : this.dataset.speedMobile);
        const speed = Math.max(10, Math.min(120, configuredSpeed || 40));
        const sizeKey = [width, viewportWidth, speed, this.reducedMotion.matches].join(':');
        if (this.lastSize === sizeKey) return;
        this.lastSize = sizeKey;
        this.removeAttribute('data-ready');
        this.track.querySelectorAll('[data-iqah-clone]').forEach((clone) => clone.remove());

        if (this.reducedMotion.matches) return;
        const copies = Math.ceil(viewportWidth / width) + 1;
        const fragment = document.createDocumentFragment();

        for (let index = 0; index < copies; index += 1) {
          const clone = this.source.cloneNode(true);
          clone.removeAttribute('data-iqah-source');
          clone.setAttribute('data-iqah-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => node.removeAttribute('data-shopify-editor-block'));
          clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
          fragment.appendChild(clone);
        }

        this.track.appendChild(fragment);
        this.style.setProperty('--iqah-distance', width + 'px');
        this.style.setProperty('--iqah-duration', width / speed + 's');
        this.setAttribute('data-ready', '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media_text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iq-media-text')) {
    customElements.define('iq-media-text', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mediaType !== 'video') return;
        const initialize = () => {
          this.video = this.querySelector('video');
          this.toggle = this.querySelector('[data-video-toggle]');
          if (!this.video || !this.toggle) return;
          this.childObserver.disconnect();
          this.initializeVideo();
        };
        this.childObserver = new MutationObserver(initialize);
        this.childObserver.observe(this, { childList: true, subtree: true });
        initialize();
      }
      initializeVideo() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.toggle = this.querySelector('[data-video-toggle]');
        this.userPaused = false;
        this.inView = false;
        this.resumeOnVisible = false;
        this.video.controls = this.dataset.nativeControls === 'true';
        if (this.toggle) this.toggle.hidden = this.video.controls;

        this.updateToggle = () => {
          if (!this.toggle) return;
          const playing = !this.video.paused && !this.video.ended;
          this.toggle.toggleAttribute('data-playing', playing);
          this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
        };
        this.playVideo = () => {
          const attempt = this.video.play();
          if (attempt) attempt.catch(() => this.updateToggle());
        };
        this.shouldAutoplay = () => this.dataset.autoplay === 'true' && !this.motion.matches && !this.userPaused;
        this.toggle?.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.playVideo();
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, options);
        this.video.addEventListener('play', this.updateToggle, options);
        this.video.addEventListener('pause', this.updateToggle, options);
        this.video.addEventListener('ended', this.updateToggle, options);
        this.video.addEventListener('click', () => {
          if (this.video.controls) this.userPaused = true;
        }, options);
        this.video.addEventListener('keydown', () => {
          if (this.video.controls) this.userPaused = true;
        }, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.video.pause();
          else if (this.inView && this.shouldAutoplay() && !document.hidden) this.playVideo();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.1;
            if (!this.inView) this.video.pause();
            else if (this.shouldAutoplay() && !document.hidden) this.playVideo();
          }, { threshold: 0.1 });
          this.observer.observe(this.video);
        } else {
          this.inView = true;
          if (this.shouldAutoplay() && !document.hidden) this.playVideo();
        }
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.resumeOnVisible = !this.video.paused;
            this.video.pause();
          } else if (this.inView && !this.motion.matches && (this.resumeOnVisible || this.shouldAutoplay())) {
            this.playVideo();
          }
        }, options);
        this.updateToggle();
      }
      disconnectedCallback() {
        this.childObserver?.disconnect();
        this.abort?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trunkbox_funktionen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iq-feature-cards')) {
    customElements.define('iq-feature-cards', class extends HTMLElement {
      connectedCallback() {
        const initialize = () => {
          if (!this.querySelector('[data-feature-ready]')) return;
          this.childObserver.disconnect();
          this.initializeSlider();
        };

        this.childObserver = new MutationObserver(initialize);
        this.childObserver.observe(this, {
          childList: true,
          subtree: true
        });

        initialize();
      }

      initializeSlider() {
        this.track = this.querySelector('[data-feature-track]');
        if (!this.track) return;

        this.cards = [...this.track.querySelectorAll('[data-feature-card]')];
        this.arrows = this.querySelector('[data-feature-arrows]');
        this.previous = this.querySelector('[data-feature-prev]');
        this.next = this.querySelector('[data-feature-next]');
        this.pagination = this.querySelector('[data-feature-pagination]');
        this.dots = this.querySelector('[data-feature-dots]');
        this.counter = this.querySelector('[data-feature-counter]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();

        const options = { signal: this.abort.signal };

        this.index = 0;
        this.stops = [0];

        this.previous.addEventListener(
          'click',
          () => this.go(this.index - 1),
          options
        );

        this.next.addEventListener(
          'click',
          () => this.go(this.index + 1),
          options
        );

        this.dots.addEventListener('click', event => {
          const button = event.target.closest('[data-feature-page]');

          if (button && this.dots.contains(button)) {
            this.go(Number(button.dataset.featurePage));
          }
        }, options);

        this.track.addEventListener('scroll', () => {
          if (this.scrollFrame) return;

          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = 0;
            this.update();
          });
        }, { ...options, passive: true });

        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || this.stops.length < 2) return;

          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let target;

          if (event.key === 'ArrowRight') {
            target = this.index + (rtl ? -1 : 1);
          }

          if (event.key === 'ArrowLeft') {
            target = this.index + (rtl ? 1 : -1);
          }

          if (event.key === 'Home') {
            target = 0;
          }

          if (event.key === 'End') {
            target = this.stops.length - 1;
          }

          if (target === undefined) return;

          event.preventDefault();
          this.go(target);
        }, options);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.refresh());
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.refresh(), options);
        }

        this.refresh();
      }

      refresh() {
        const max = Math.max(
          0,
          this.track.scrollWidth - this.track.clientWidth
        );

        const first = this.cards[0]?.getBoundingClientRect();
        const second = this.cards[1]?.getBoundingClientRect();

        const step = first && second
          ? Math.abs(second.left - first.left)
          : this.track.clientWidth;

        this.stops = [0];

        if (max > 2 && step > 1) {
          for (
            let position = step;
            position < max - 2;
            position += step
          ) {
            this.stops.push(position);
          }

          this.stops.push(max);
        }

        const overflow = this.stops.length > 1;

        this.arrows.hidden =
          !overflow || this.dataset.showArrows !== 'true';

        this.pagination.hidden =
          !overflow || this.dataset.showDots !== 'true';

        const useCounter = this.stops.length > 12;

        this.counter.hidden = !useCounter;
        this.dots.hidden = useCounter;

        this.counter.querySelector('[data-feature-total]').textContent =
          this.stops.length;

        if (this.dotCount !== this.stops.length) {
          this.dots.replaceChildren();

          if (!useCounter) {
            this.stops.forEach((_, index) => {
              const button = document.createElement('button');

              button.type = 'button';
              button.className = 'iq-fc__dot';
              button.dataset.featurePage = index;

              button.setAttribute(
                'aria-label',
                `${this.dataset.goLabel} ${index + 1}`
              );

              button.setAttribute('aria-controls', this.track.id);
              this.dots.append(button);
            });
          }

          this.dotCount = this.stops.length;
        }

        this.update();
      }

      update() {
        const position = Math.abs(this.track.scrollLeft);

        this.index = this.stops.reduce((closest, stop, index) => {
          return Math.abs(stop - position) <
            Math.abs(this.stops[closest] - position)
            ? index
            : closest;
        }, 0);

        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.stops.length - 1;

        [...this.dots.children].forEach((button, index) => {
          if (index === this.index) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });

        this.counter.querySelector('[data-feature-current]').textContent =
          this.index + 1;
      }

      go(index) {
        const target = Math.max(
          0,
          Math.min(index, this.stops.length - 1)
        );

        const direction =
          getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;

        this.track.scrollTo({
          left: this.stops[target] * direction,
          behavior: this.motion.matches ? 'auto' : 'smooth'
        });
      }

      disconnectedCallback() {
        this.childObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.abort?.abort();
        cancelAnimationFrame(this.scrollFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
